import { __awaiter } from "tslib";
import ApiService from '../services/ApiService';
class MyUploadAdapter {
    constructor(loader) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }
    // Starts the upload process.
    upload() {
        return this.loader.file.then((file) => {
            return new Promise((resolve, reject) => {
                // this._initRequest();
                this._initListeners(resolve, reject, file);
                // this._sendRequest(file);
            });
        });
    }
    _initListeners(resolve, reject, file) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams({
                ver: 'v1',
                isImage: 'true'
            }).toString() || '';
            const url = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}/api/upload/image?${params}`;
            const formdata = new FormData();
            formdata.append('request', file);
            try {
                const resp = yield ApiService.post(url, formdata);
                resolve({
                    default: resp.data.result.content.url
                });
                this.loader.uploaded = true;
            }
            catch (err) {
                const genericErrorText = `Couldn't upload file: ${file.name}.`;
                reject(((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.statusText) || genericErrorText);
            }
        });
    }
}
export function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        // Configure the URL to the upload script in your back-end here!
        return new MyUploadAdapter(loader);
    };
}
